import React from "react";
import { Pill } from "./Pill";

type Status = "active" | "suspended" | "inactive" | 0 | 1 | boolean | null | undefined;

export function StatusPill({ status }: { status: Status }) {
  if (status === "active" || status === 1 || status === true) {
    return <Pill kind="active">Active</Pill>;
  }
  if (status === "suspended") return <Pill kind="suspended">Suspended</Pill>;
  return <Pill kind="inactive">Inactive</Pill>;
}
